export const defaultWackValues: any = {
  'modifiers.wack.influence': 0.5,
  'modifiers.wack.offsetX': 0.5,
  'modifiers.wack.offsetY': 0.5,
  'modifiers.wack.offsetZ': 0.5,
  'modifiers.wack.scaleX': 0.5,
  'modifiers.wack.scaleY': 0.5,
  'modifiers.wack.scaleZ': 0.5,
  'modifiers.wack.rotateX': 0.5,
  'modifiers.wack.rotateY': 0.5,
  'modifiers.wack.rotateZ': 0.5,
  'modifiers.wack.taperTopX': 0.5,
  'modifiers.wack.taperTopY': 0.5,
};

export const wackMap: any = {
  slant: {
    xKey: 'modifiers.wack.offsetX',
    yKey: 'modifiers.wack.offsetY',
  },
  tilt: {
    xKey: 'modifiers.wack.rotateZ',
    yKey: 'modifiers.wack.rotateX',
  },
  taper: {
    xKey: 'modifiers.wack.taperTopX',
    yKey: 'modifiers.wack.taperTopY',
  },
  scale: {
    xKey: 'modifiers.wack.scaleX',
    yKey: 'modifiers.wack.scaleY',
  },
};
